/**
 * 作用于哪些页面
 * 注明代码业务/功能说明
 * @authors kanglimei
 * @date    2018/8/6
 * @version v1.0
 */

import wx from 'weixin-js-sdk'

let wxshare = {
}

// 微信分享使用方法
wxshare.init = function (requestUrl, shareTitle, shareImg, shareDesc, signature, appid, timestamp, nonceStr) {
  let links = requestUrl // 分享出去的链接
  let title = shareTitle // 分享的标题
  let image = shareImg
  let desc = shareDesc // 分享的详情介绍
  // alert('requestUrl:' + requestUrl)
  // alert('signature:' + signature)
  // alert('appId:' + appid)
  // alert('timestamp:' + timestamp)
  // alert('nonceStr:' + nonceStr)
  // alert('image:' + image)
  wx.config({
    debug: false,
    appId: appid,
    timestamp: timestamp,
    nonceStr: nonceStr,
    signature: signature,
    jsApiList: [
      'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo'
    ]
  })
  wx.ready(function () {
    wx.onMenuShareTimeline({
      title: title, // 分享标题
      link: links, // 分享链接'
      imgUrl: image, // 分享图标
      success: function () {
        // 分享纪录
        // shareRecord();
        // alert("分享到朋友圈成功")
      },
      cancel: function () {
        // alert("分享失败,您取消了分享!")
      }
    })
    // wx.onMenuShareAppMessage({
    //     title: title, // 分享标题
    //     desc: description, // 分享描述
    //     link: link, // 分享链接
    //     imgUrl: cover, // 分享图标
    //     success: function () {
    //         alert("成功分享给朋友")
    //     },
    //     cancel: function () {
    //         alert("分享失败,您取消了分享!")
    //     }
    // });

    // 微信分享菜单测试
    wx.onMenuShareAppMessage({
      title: title, // 分享标题
      desc: desc, // 分享描述
      link: links, // 分享链接
      imgUrl: image, // 分享图标
      success: function () {
        // 分享纪录
        // shareRecord();
        // alert("成功分享给朋友")
      },
      cancel: function () {
        // alert("分享失败,您取消了分享!")
      }
    })

    wx.onMenuShareQQ({
      title: title, // 分享标题
      desc: desc, // 分享描述
      link: links, // 分享链接
      imgUrl: image, // 分享图标
      success: function () {
        // 分享纪录
        // shareRecord();
        // alert("成功分享给QQ")
      },
      cancel: function () {
        // alert("分享失败,您取消了分享!")
      }
    })
    wx.onMenuShareWeibo({
      title: title, // 分享标题
      desc: desc, // 分享描述
      link: links, // 分享链接
      imgUrl: image, // 分享图标
      success: function () {
        // 分享纪录
        // shareRecord();
        // alert("成功分享给朋友")
      },
      cancel: function () {
        // alert("分享失败,您取消了分享!")
      }
    })
  })
  wx.error(function (res) {
    console.log(res)
    // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
  })
}

// 判断是否微信登陆
wxshare.isWeiXin = function () {
  let ua = window.navigator.userAgent.toLowerCase()
  if ((ua.match(/MicroMessenger/i) + '') === 'micromessenger') {
    return true
  } else {
    return false
  }
}

wxshare.isMobile = function () {
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  return flag
}

// 通过userAgent判断IOS环境
wxshare.isIOS = function () {
  let isIphone = navigator.userAgent.includes('iPhone')
  let isIpad = navigator.userAgent.includes('iPad')
  return isIphone || isIpad
}

// 去除html的标签，返回内容
wxshare.deleteHtmlTag = function (str) {
  return str.replace(/<[^>]+>/g, '')
}

// 判断是否微信登陆
wxshare.getSignature = function (encodeRequestUrl, requestUrl, shareTitle, shareImg, shareDesc) {
  if (this.isWeiXin()) {
    let signature = ''
    this
      .$fetch('http://jiedong-admin.torinosrc.com:52014/api/v1/weixin/signature?url=' + encodeRequestUrl)
      .then(function (response) {
        // alert(encodeRequestUrl)
        // alert(response.data.signature)
        // alert(requestUrl)
        signature = response.data.signature
        let timestamp = response.data.timestamp
        let noncestr = response.data.noncestr
        let appid = response.data.appId
        this.init(requestUrl, shareTitle, shareImg, shareDesc, signature, appid, timestamp, noncestr)
      })
      .catch(function (err) {
        console.log(err)
      })
  }
}

export default wxshare



// WEBPACK FOOTER //
// ./src/libs/wx.js